var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPremiumPlus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "19px",
    viewBox: "0 0 23 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPremiumPlus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M235.099807,436.612223 C234.12043,436.612223 233.288403,437.403866 233.288403,438.442968 C233.288403,438.788962 233.386452,439.085688 233.533247,439.333147 L228.882316,444.132834 C227.609902,442.054631 226.777875,438.987153 226.336934,436.958217 C227.022165,436.612223 227.511853,435.919675 227.511853,435.078204 C227.511853,433.940566 226.581778,433 225.455605,433 C224.329987,433 223.399357,433.940566 223.399357,435.078204 C223.399357,435.919675 223.889046,436.612223 224.574277,436.958217 C224.13389,438.987153 223.301309,442.054631 222.028341,444.132834 L217.377963,439.333147 C217.524759,439.085688 217.622808,438.788962 217.622808,438.442968 C217.622808,437.453134 216.839528,436.612223 215.811404,436.612223 C214.78328,436.612223 214,437.403866 214,438.442968 C214,439.432242 214.78328,440.273713 215.811404,440.273713 L219.140066,451.653446 C219.189367,451.851637 219.385464,452 219.629754,452 L231.330204,452 C231.526301,452 231.721844,451.851637 231.819892,451.653446 L235.099807,440.223885 C236.079184,440.223885 236.911765,439.432242 236.911765,438.39314 C236.862464,437.403866 236.079184,436.612223 235.099807,436.612223",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Members-Grid-OFF-See-less",
    transform: "translate(-214.000000, -433.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icPremiumPlus",
    fill: "#F76B46",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPremiumPlus);
export default __webpack_public_path__ + "static/media/icPremiumPlus.ae7dc651ba9795c95459f19b628f70e6.svg";
export { ForwardRef as ReactComponent };